/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dice Roller (d4–d20, Roll Online) — Toolverse`)
};

const es_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzador de Dados (d4–d20, Tirar Online) — Toolverse`)
};

const de_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfel-Generator (d4–d20, online würfeln) — Toolverse`)
};

const nl_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobbelsteen Gooien (d4-d20, Online) — Toolverse`)
};

const fr_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanceur de Dés (d4–d20, En Ligne) — Toolverse`)
};

const it_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanciadadi (d4–d20, lancia online) — Toolverse`)
};

const pt_br2_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolador de Dados (d4–d20, Role Online) — Toolverse`)
};

const pt_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançador de Dados (d4–d20, Lançar Online) — Toolverse`)
};

const ja_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイコロ(d4〜d20、オンラインで振る) — Toolverse`)
};

const zh_dice_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`骰子生成器（d4–d20，在线掷骰）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_meta_title", locale)
	if (locale === "en") return en_dice_meta_title(inputs)
	if (locale === "es") return es_dice_meta_title(inputs)
	if (locale === "de") return de_dice_meta_title(inputs)
	if (locale === "nl") return nl_dice_meta_title(inputs)
	if (locale === "fr") return fr_dice_meta_title(inputs)
	if (locale === "it") return it_dice_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_dice_meta_title(inputs)
	if (locale === "pt") return pt_dice_meta_title(inputs)
	if (locale === "ja") return ja_dice_meta_title(inputs)
	return zh_dice_meta_title(inputs)
};